<template>
  <material-card
    :title="title"
    data-testId="material-card-title"
    color="dover-blue">
    <v-form
      v-if="siteInfo.name !== undefined"
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs9
            md5>
            <v-text-field
              v-model.trim="siteInfo.name"
              :rules="rules.required.concat(rules.max22)"
              :label="`${ $t('Name') }`"
              :counter="22"
              data-testId="text-field-Name"
              validate-on-blur
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs3
            md4/>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.trim="siteInfo.consoleSerial"
              :disabled="!Maglink.IsSuperAdminUser()"
              :counter="6"
              :rules="rules.required"
              :label="`${ $t('Console serial') }`"
              data-testId="text-field-Console-serial"
              mask="######"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md7>
            <v-text-field
              v-model.trim="siteInfo.header1"
              :rules="rules.max34"
              :label="`${ $t('Address') + ' 1'}`"
              :counter="34"
              data-testId="text-field-Address-1"
              validate-on-blur
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md7>
            <v-text-field
              v-model.trim="siteInfo.header2"
              :rules="rules.max34"
              :label="`${ $t('Address') + ' 2' }`"
              :counter="34"
              data-testId="text-field-Address-2"
              validate-on-blur
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md7>
            <v-text-field
              v-model.trim="siteInfo.header3"
              :rules="rules.max34"
              :label="`${ $t('Address') + ' 3' }`"
              :counter="34"
              data-testId="text-field-Address-3"
              validate-on-blur
              class="dover-input"/>
          </v-flex>
        </v-layout>
        <v-layout
          wrap>
          <v-flex
            xs6
            md3>
            <v-select
              v-model.number="tanksNumber"
              :items="a1_32List"
              :label="`${ $t('Total tanks') }`"
              data-testId="select-Total-tanks"
              item-text=""
              item-value=""
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item"
                  data-testId="chip"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item }}</v-avatar>
                  {{ $t('Tanks') }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-select
              v-model.number="siteInfo.externalRelays"
              :items="a0_32x8List"
              :label="`${ $t('Total external relays') }`"
              data-testId="select-Total-external-relays"
              item-text=""
              item-value=""
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item"
                  data-testId="chip-2"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item }}</v-avatar>
                  {{ $t('Relays') }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            v-if="Maglink.isPlus"
            xs6
            md3>
            <v-select
              v-model.number="siteInfo.externalOM4Relays"
              :items="a0_16x4List"
              :label="`${ $t('Total OM4 relays') }`"
              data-testId="select-Total-OM4-relays"
              item-text=""
              item-value=""
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item"
                  data-testId="chip-3"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item }}</v-avatar>
                  {{ $t('OM4 relays') }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            v-if="Maglink.isPlus"
            xs12
            text-xs-left>
            <v-select
              :items="devices"
              :label="`${ $t('Devices') }`"
              data-testId="select-Devices"
              box
              solo />
          </v-flex>
          <v-flex
            v-if="progressBar.loading"
            xs12>
            <span>{{ progressBar.label }}</span>
            <MaglinkComponentLoadingBar
              :loading="progressBar.loading"
              :indeterminate="false"
              :max-value="progressBar.maxValue"
              :value="progressBar.currentValue"
              data-testId="MaglinkComponentLoadingBar" />
          </v-flex>
          <v-flex
            v-if="Maglink.isPlus"
            xs6
            text-xs-left>
            <v-btn
              :disabled="detectionRequested || !Maglink.IsAdminUser()"
              data-testId="btn-Detect-devices"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="detect">
              {{ $t('Detect devices') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    features: {
      type: Object,
      required: true,
      default: () => {}
    },
    tanks: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      range0_4: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 4) ],
      range0_32: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 32) ],
      range1_32: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 32) ],
      range1_256: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 256) ],
      max22: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 22) ],
      max34: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 34) ]
    },
    siteInfo: {},
    devices: [],
    a0_16x4List: undefined,
    a0_32x8List: undefined,
    a1_32List: undefined,
    responseTimerId: 0,
    responseTimeCount: 0,
    detectionRequested: false,
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0,
      tickId: 0,
      label: ''
    },
    maxTankNumber: 12,
    tanksNumber: 1,
    tankSerialize: []
  }),
  watch: {
    tanks: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (newVal !== undefined) {
          newVal.forEach(tank => {
            this.tankSerialize.push({ tankNumber: tank.tankNumber, serialize: tank.serialize })
          })
        }
      }
    }
  },
  mounted () {
    this.a0_16x4List = []
    this.a0_32x8List = []
    this.a1_32List = []
    for (let index = 0; index <= 4; index++) {
      this.a0_16x4List.push(index * 4)
    }
    for (let index = 0; index <= 4; index++) {
      this.a0_32x8List.push(index * 8)
    }

    if (Vue.prototype.Maglink.isPlus) {
      this.maxTankNumber = 12
    } else {
      this.maxTankNumber = 16
    }
    for (let index = 1; index <= this.maxTankNumber; index++) {
      this.a1_32List.push(index)
    }

    this.Maglink.GetSettings('SiteInfo')
      .then(response => {
        this.siteInfo = { ...this.siteInfo, ...response.data }
        if (this.siteInfo.tanksNumber > this.maxTankNumber) {
          this.tanksNumber = this.maxTankNumber
        } else {
          this.tanksNumber = this.siteInfo.tanksNumber
        }
      })
      .catch(error => (this.snack('error', error.message)))

    this.startProgressBarTimer()
    this.startResponseTimer(2000)
  },
  methods: {
    stopProgressBarTimer () {
      clearInterval(this.progressBar.tickId)
      this.progressBar.tickId = 0
      this.progressBar.loading = false
      this.progressBar.currentValue = 0
      this.progressBar.label = ''
    },
    startProgressBarTimer () {
      // manage progressbar to show user to wait
      if (this.progressBar.tickId === 0) {
        this.progressBar.label = this.$t('Awaiting for device response...')
        this.progressBar.loading = true
        this.progressBar.currentValue = 0
        this.progressBar.tickId = setInterval(this.progressBarTick, 100)
      }
    },
    progressBarTick () {
      if (this.progressBar.currentValue >= this.progressBar.maxValue) {
        this.progressBar.currentValue = 0
      }
      this.progressBar.currentValue += 1
    },
    startResponseTimer (msecs) {
      this.responseTimerId = setTimeout(this.responseCommandTimerTick, msecs)
      this.responseTimeCount = 0
    },
    responseCommandTimerTick () {
      if (this.responseTimeCount > 36) {
        this.detectionRequested = false
        this.stopProgressBarTimer()
        this.snack('error', this.$t('No response from devices'))
        return
      }
      // read response
      this.Maglink.GetAutodetectionStatus()
        .then(response => {
          // response.data.updated
          if (response.data.updated) {
            this.stopProgressBarTimer()
            this.getDetectedDevices()
          } else {
            this.responseTimerId = setTimeout(this.responseCommandTimerTick, 4000)
            this.responseTimeCount += 1
          }
        })
        .catch(error => {
          this.snack('error', error.message)
        })
    },
    save: function (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        if (this.siteInfo.tanksNumber !== this.tanksNumber) this.siteInfo.tanksNumber = this.tanksNumber
        let info = { ...this.siteInfo }
        info['tanks'] = this.tankSerialize
        this.Maglink.SetSettings('SiteInfo', info)
          .then(response => (this.snack('success', response.data['done'])))
          .catch(error => (this.snack('error', error.message)))

        this.$emit('settingsSaved')
      } else {
        this.isValidationOk = false
      }
    },
    detect: function (event) {
      if (this.progressBar.loading) {
        return
      }
      this.detectionRequested = true
      this.devices = []
      this.Maglink.StartAutodetection(0, 0)
        .then(response => {
          this.startProgressBarTimer()
          this.startResponseTimer(2000)
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getDetectedDevices () {
      this.Maglink.GetAutodetections()
        .then(response => {
          response.data.forEach(item => {
            var text = this.Maglink.DetectedSerialName(item)
            if (text !== '') {
              this.devices.push(text)
            }
          })
          if (this.detectionRequested) {
            this.snack('success', this.$t('Devices detected'))
          }
          this.detectionRequested = false
        })
        .catch(error => (this.snack('error', error.message)))
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
